import PennyCheck from './penny-check';

export default PennyCheck;
